export const TEMP_SNACKBAR_DURATION = 3000;
//# sourceMappingURL=ImpSnackbarTypes.js.map